// Mitmach-Kalender: Termine aus der Gegend und ihr Weg durch die Redaktion.
//
// Ein Hörer reicht einen Termin ein, die Redaktion sieht ihn durch und gibt ihn
// frei. Freigegeben heißt öffentlich: Der Termin steht auf der Hörerseite, liegt
// im Kalender-Abo und taucht im Studio auf.
//
// Wege durch die Zustände:
//   Wartet ──freigeben──▶ Freigegeben ──zurückziehen──▶ Wartet
//      │                       │
//   ablehnen              zusammenführen
//      ▼                       ▼
//   Abgelehnt              Doppelt (zeigt auf den Termin, der bleibt)
//
// Freigeben, ablehnen und zurückziehen darf, wer auch Beiträge freigibt: die
// Redaktionsleitung und Admins. Das ist bewusst dasselbe Recht – ein zweiter
// Freigabe-Ablauf mit eigenen Rollen wäre für ein kleines Radio nur Ballast.
export const EVENT_STATUSES = ["pending", "approved", "rejected", "merged"];
export const EVENT_STATUS_LABEL = {
    pending: "Wartet auf Freigabe",
    approved: "Freigegeben",
    rejected: "Abgelehnt",
    merged: "Doppelt",
};
export const EVENT_ACTIONS = ["approve", "reject", "retract"];
export const EVENT_ACTION_LABEL = {
    approve: "Freigeben",
    reject: "Ablehnen",
    retract: "Zurückziehen",
};
/**
 * Nächster Zustand für eine Aktion – oder eine Begründung, warum das gerade nicht
 * geht. Reine Funktion: Die Regeln lassen sich ohne Datenbank prüfen, und Suite,
 * Studio und API rechnen mit denselben.
 */
export function nextEventStatus(current, action, rights) {
    if (!rights.mayPublish) {
        return { ok: false, error: "Termine gibt die Redaktionsleitung frei." };
    }
    if (current === "merged") {
        return { ok: false, error: "Dieser Termin wurde mit einem anderen zusammengeführt." };
    }
    switch (action) {
        case "approve":
            if (current === "approved")
                return { ok: false, error: "Dieser Termin steht schon öffentlich." };
            return { ok: true, status: "approved" };
        case "reject":
            if (current === "rejected")
                return { ok: false, error: "Dieser Termin ist schon abgelehnt." };
            return { ok: true, status: "rejected" };
        case "retract":
            if (current !== "approved")
                return { ok: false, error: "Dieser Termin steht gar nicht öffentlich." };
            return { ok: true, status: "pending" };
        default:
            return { ok: false, error: "Unbekannte Aktion." };
    }
}
/** Welche Zustände auf der Hörerseite zu sehen sind. */
export function isPublicEventStatus(status) {
    return status === "approved";
}
export function isEventStatus(value) {
    return typeof value === "string" && EVENT_STATUSES.includes(value);
}
// ---------------------------------------------------------------- Doppelte finden
/**
 * Zwei Schreibweisen desselben Festes vergleichbar machen: „Sommerfest der
 * Feuerwehr Prüm“ und „Sommerfest Feuerwehr Prüm“ sollen sich finden.
 */
export function normalizeTitle(title) {
    return title
        .toLowerCase()
        .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
        .replace(/[^a-z0-9]+/g, " ")
        .trim()
        .split(" ")
        // Füllwörter tragen nichts zum Vergleich bei.
        .filter((w) => w.length > 2 && !["der", "die", "das", "den", "dem", "des", "und", "fuer", "vom", "zum", "zur"].includes(w))
        .join(" ");
}
/**
 * Wie ähnlich sind sich zwei Titel? 0 heißt „nichts gemeinsam“, 1 „dasselbe“.
 * Gezählt werden gemeinsame Wörter – das reicht, um Doppelte zum Prüfen
 * vorzuschlagen. Entscheiden tut immer ein Mensch.
 */
export function titleSimilarity(a, b) {
    const left = new Set(normalizeTitle(a).split(" ").filter(Boolean));
    const right = new Set(normalizeTitle(b).split(" ").filter(Boolean));
    if (left.size === 0 || right.size === 0)
        return 0;
    let shared = 0;
    for (const w of left)
        if (right.has(w))
            shared += 1;
    return shared / Math.max(left.size, right.size);
}
/** Ab hier schlägt die Suite zwei Termine als „vielleicht dasselbe“ vor. */
export const DUPLICATE_THRESHOLD = 0.6;
